import React from 'react';
import { useTranslation } from 'react-i18next';

const Reviews = () => {
    const { t } = useTranslation();


    const reviews = [
        {
            id: 1,
            name: "Ahmed Ali",
            rating: 5,
            comment: "Excellent service and professional staff.",
            date: "2023-10-15"
        },
        {
            id: 2,
            name: "Sarah Mohamed",
            rating: 5,
            comment: "Very clean and fast results.",
            date: "2023-11-02"
        },
        {
            id: 3,
            name: "Mohamed Hassan",
            rating: 4,
            comment: "Good experience overall.",
            date: "2023-09-20"
        }
    ];

    return (
        <div className="container py-5">
            <h2 className="section-title">{t('reviews.title', 'Customer Reviews')}</h2>

            <div className="row justify-content-center">
                {reviews.map((review) => (
                    <div key={review.id} className="col-md-6 col-lg-4 mb-4">
                        <div className="card h-100 shadow-sm border-0">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="card-title mb-0">{review.name}</h5>
                                    <div className="text-warning">
                                        {[...Array(review.rating)].map((_, i) => (
                                            <i key={i} className="fas fa-star"></i>
                                        ))}
                                    </div>
                                </div>
                                <p className="card-text text-muted">{review.comment}</p>
                                <small className="text-muted">{review.date}</small>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Reviews;
